import { Component, Input, OnChanges } from "@angular/core";
import { FormCategory } from "src/app/components/default/form/form-category";
import { FormField } from "src/app/components/default/form/form-field";
import { FormFields } from "src/app/components/default/form/form.definition";
import { FormOptions } from "src/app/components/default/form/form.interface";
import { FormComponent } from "../../../../form/form.component";
import { TableField } from "../../../table-field";
import { TableHeader } from "../../../table-header";
import { TableRow } from "../../../table-row";

@Component({
  selector: "app-table-tile",
  imports: [FormComponent],
  templateUrl: "./table-tile.component.html",
  styleUrl: "./table-tile.component.less",
})
export class TableTileComponent implements OnChanges {
  @Input({ required: true })
  public row: TableRow;

  @Input({ required: true })
  public headers: TableHeader[];

  public fields: FormFields;

  public options: FormOptions;

  public constructor() {
    this.row = new TableRow();
    this.headers = [];
    this.fields = new Map();
    this.options = {
      attachments: false,
      foot: false,
      head: false,
      multi: false,
      title: false,
    };
  }

  public ngOnChanges(): void {
    this.fields.clear();

    const category = new FormCategory("Algemeen");

    let headerIndex = 0;
    let fieldIndex = 0;
    const fields: Map<number, FormField> = new Map();
    for (const header of this.headers) {
      const field = this.row.fields.at(headerIndex);
      headerIndex++;
      if (!field || !header.options.tile) continue;

      const formField = new FormField(header.name, field?.value.value, header.pfx, header.label);
      formField.extras = this.getExtras(header, field);
      formField.readonly = true;
      fields.set(fieldIndex, formField);
      fieldIndex++;
    }
    category.setFields(fields);
    this.fields.set(0, category);
  }

  private getExtras(header: TableHeader, field: TableField): Record<string, unknown> | null {
    switch (header.pfx) {
      case "lni":
        return { ...field.extras, size: 100 };
      default:
        return field.extras;
    }
  }
}
